import { render, staticRenderFns } from "./applyChg.vue?vue&type=template&id=6a1bf85a&scoped=true&"
import script from "./applyChg.vue?vue&type=script&lang=js&"
export * from "./applyChg.vue?vue&type=script&lang=js&"
import style0 from "./applyChg.vue?vue&type=style&index=0&id=6a1bf85a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1bf85a",
  null
  
)

export default component.exports